import React from 'react';
import Cropper from 'react-easy-crop';

export default Cropper;
